/**
 * @fileOverview This file contains the implementation of the TutorialCard component for the Tutorials catalog
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import {
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
} from "@mui/material";
//#endregion

const TutorialCard = ({ tutorial }) => {
  return (
    <Card
      key={tutorial.id}
      sx={{ width: "30%", height: "30%" }}
      className="tutorial-card"
    >
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" fontWeight="bold">
          {tutorial.title}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Ver tutorial</Button>
      </CardActions>
    </Card>
  );
};

export default TutorialCard;
